import { Document, Page, StyleSheet } from '@react-pdf/renderer';
import EuropassPdfBusinessSkillsSection from "./EuropassPdfBusinessSkillsSection";
import EuropassPdfDiplomasSection from "./EuropassPdfDiplomasSection";
import EuropassPdfExperiencesSection from "./EuropassPdfExperiencesSection";
import EuropassPdfFooter from "./EuropassPdfFooter";
import EuropassPdfHeader from "./EuropassPdfHeader";
import EuropassPdfHobbiesSection from "./EuropassPdfHobbiesSection";
import EuropassPdfIntroductionSection from "./EuropassPdfIntroductionSection";
import EuropassPdfLanguageSkillsSection from "./EuropassPdfLanguageSkillsSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function EuropassPdf( { resumeData, translations } ) {

    const { isExperienceHidden } = extractResumeProperties( resumeData );

    const styles = StyleSheet.create( {
        page: {
            flexDirection: 'column',
            fontSize: 10,
            textAlign: 'justify',
            fontFamily: 'Verdana, sans-serif',
            margin: 20,
            marginBottom: 50,
            paddingBottom: 50
        },
    } );

    return (
        <Document>
            <Page size="A4" style={ styles.page } wrap>
                <EuropassPdfHeader resumeData={ resumeData } translations={ translations }/>
                <EuropassPdfIntroductionSection resumeData={ resumeData } translations={ translations }/>
                { !isExperienceHidden && (
                    <EuropassPdfExperiencesSection resumeData={ resumeData } translations={ translations }/>
                ) }
                <EuropassPdfDiplomasSection resumeData={ resumeData } translations={ translations }/>
                <EuropassPdfLanguageSkillsSection resumeData={ resumeData } translations={ translations }/>
                <EuropassPdfBusinessSkillsSection resumeData={ resumeData } translations={ translations }/>
                <EuropassPdfHobbiesSection resumeData={ resumeData } translations={ translations }/>
                <EuropassPdfFooter resumeData={ resumeData } translations={ translations }/>
            </Page>
        </Document>
    );
}
